import React, { Component } from 'react';

// eslint-disable-next-line
class SocialLinks extends Component {
  render() {
    return (
      <ul className="header__social">
        <li className="header__social__item"><a href="http://twitter.com/rluijtenant" className="social__anchor-link" target="_blank" rel="noopener noreferrer">twitter</a></li>
        <li className="header__social__item"><a href="http://linkedin.com/in/ruudluijten" className="social__anchor-link" target="_blank" rel="noopener noreferrer">linkedin</a></li>
        <li className="header__social__item"><a href="https://www.instagram.com/rluijtenant" className="social__anchor-link" target="_blank" rel="noopener noreferrer">instagram</a></li>
      </ul>
    );
  }
}

export default SocialLinks;



// WEBPACK FOOTER //
// ./client/js/components/shared/SocialLinks.js